import axios from 'axios';
import httpClient from '../httpClient';

export const createSavedSearch = (params) => {
    return httpClient
        .post('/api/v2/saved_search/create', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getSavedSearchById = (id, sorting, daysBefore) => {
    return httpClient
        .get(`/api/v2/saved_search/${id}?help=false&count=true&page=1&itemsOnPage=1000&daysBefore=${daysBefore}&sorting=${sorting}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getCompaniesForSearch = () => {
    return httpClient
        .get('/api/v2/search_feed')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getSavedSearchResults = (params) => {
    const {keyword, entities, typesNotIn, sentiments, period} = params;
    // let encodedSearchValue = encodeURIComponent(keyword);
    let removeAmpersand = keyword.replace(/&/g," ");
    let url = `/api/v2/saved_search/preview?keyword=${removeAmpersand}&period=${period}`;
    // let url = `/api/v2/saved_search/preview?keyword=${keyword}&period=${period}`;
    // let url = `/api/v2/saved_search/preview?keyword=${encodedSearchValue}&period=${period}`;
    entities.length > 0 && entities.map(id => {
        return url += `&entities%5B%5D=${id}`;
    });
    typesNotIn && typesNotIn.length > 0 && typesNotIn.map(source => {
        return url += `&typesNotIn%5B%5D=${source}`;
    });
    sentiments && sentiments.length > 0 && sentiments.map(sentiment => {
        return url += `&sentiments%5B%5D=${sentiment}`;
    });
    return httpClient
        .get(url)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const editSavedSearch = (params, id) => {
    // params.keyword = encodeURIComponent(params.keyword);
    return httpClient
        .patch(`/api/v2/saved_search/${id}`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const deleteSavedSearch = (id) => {
    return httpClient
        .delete(`/api/v2/saved_search/${id}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getSavedSearches = () => {
    return httpClient
        // .get('/api/v2/search_feed/get_all')
        .get('/api/v2/saved_search')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getSavedSearchesForAlerts = () => {
    return httpClient
        .get('/api/v2/search_feed/get_all')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

